import { cn } from "@/lib/utils";

type TagDesignType = "old-design" | "new-design";

export const Tag = ({
  tag,
  large,
  type,
}: {
  tag: string;
  large?: boolean;
  type?: TagDesignType;
}) => {
  return (
    <article
      className={cn(
        "px-1 text-white rounded-sm  w-fit",
        large ? "text-sm desktop:text-xs" : "text-xs",
        type === "new-design" ? "bg-information" : "bg-primary-blue",
      )}
    >
      {tag}
    </article>
  );
};

export const NewTag = ({
  type = "old-design",
  tag,
}: {
  type?: TagDesignType;
  tag?: string;
}) =>
  type === "old-design" ? (
    <article
      className={cn(
        "my-auto rounded-md text-xs px-1 text-gray-900 font-bold pt-[2px] mb-[2px]",
        "bg-[linear-gradient(294deg,_#EF8241_25.98%,_#FFA02E_69.8%)]",
      )}
    >
      NEW
    </article>
  ) : (
    <article
      className={cn(
        "flex items-center justify-center rounded-md text-xs px-1 py-0.5 text-white bg-information font-bold",
      )}
    >
      NEW
    </article>
  );
